/* eslint-disable prefer-template */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-var */
import AppConsts from './appconst';
import { Utils } from '@utils';

declare const abp: any;

export const initSignalR = () => {
  var encryptedAuthToken = abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

  if (!encryptedAuthToken) return;

  abp.signalr = {
    autoConnect: true,
    connect: undefined,
    hubs: undefined,
    qs:
      AppConsts.authorization.encrptedAuthTokenName + '=' + encodeURIComponent(encryptedAuthToken),
    remoteServiceBaseUrl: AppConsts.remoteServiceBaseUrl,
    url: 'signalr',
  };

  Utils.loadScript(AppConsts.appBaseUrl + '/umoto.signalr-client.js');
};
